// Шапка полноэкранного предпросмотра: где мы в уроке и чем управляем.
import type { ReactNode } from 'react'
import { ArrowLeft, RotateCcw, X } from 'lucide-react'
import { Button, DialogTitle } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  /** Позиция в уроке словами — на экране «урок пройден» её нет. */
  position: string | null
  canGoBack: boolean
  onBack: () => void
  onRestart: () => void
  onClose: () => void
  /** Навигация предпросмотра (урок + язык показа) — `PreviewHeaderControls`.
   *  Слотом, а не пропами: шапка не должна знать ни про курс, ни про язык. */
  controls?: ReactNode
}

export const PreviewRunHeader = ({
  position,
  canGoBack,
  onBack,
  onRestart,
  onClose,
  controls,
}: Props) => {
  const m = useMessages(messages)
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-border px-4">
      <Button
        variant="ghost"
        size="sm"
        onClick={onBack}
        disabled={!canGoBack}
        className="text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="mr-1.5 h-4 w-4" />
        {m.back}
      </Button>
      {controls}
      <div className="flex min-w-0 flex-1 flex-col items-center">
        <DialogTitle className="text-sm font-semibold">{m.title}</DialogTitle>
        {position ? <span className="text-xs text-muted-foreground">{position}</span> : null}
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onRestart}
        className="text-muted-foreground hover:text-foreground"
      >
        <RotateCcw className="mr-1.5 h-4 w-4" />
        {m.restart}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={onClose}
        className="text-muted-foreground hover:text-foreground"
      >
        <X className="mr-1.5 h-4 w-4" />
        {m.close}
      </Button>
    </header>
  )
}
